/*@ngInject*/
const DataSetUtil = function (coreMediator, dataSetType) {

    this.getDataSetParamsByName = function (dataSetName, variableName, submissionUri, ownerUri, formRowUri) {
        return {
            name: dataSetName,
            submissionUri: submissionUri,
            ownerUri: ownerUri,
            formRowUri: formRowUri,
            variableName: variableName
        };
    };

    this.getDataSetParams = function (dataSet, variableName, submissionUri, ownerUri, formRowUri, searchString) {
        return {
            name: dataSet.name,
            submissionUri: submissionUri,
            ownerUri: ownerUri,
            formRowUri: formRowUri,
            variableName: dataSet.includeVariableNameInDynamicDataSetBinding ? variableName : null,
            search: searchString
        };
    };

    this.getDataSetParamsByFieldStructure = function (dataSet, fieldStructure, searchString) {
        const submissionId = fieldStructure.parentForm.submissionId;
        const submissionUri = !_.isNil(submissionId) ? `com.firstbest.underwriting.submission.Submission:${submissionId}` : null;
        const ownerUri = _.replace(fieldStructure.parentForm.uri, 'FormSummary', 'Form');
        const formRowUri = this.getFormRowUri(dataSet, fieldStructure);
        const variableName = fieldStructure.uiField.fieldTemplate.variableName;

        return {
            name: dataSet.name,
            submissionUri: submissionUri,
            ownerUri: ownerUri,
            formRowUri: formRowUri,
            variableName: dataSet.includeVariableNameInDynamicDataSetBinding ? variableName : null,
            search: searchString
        };
    };

    this.getFormRowUri = function (dataSet, fieldStructure) {
        let result = null,
            sourceFieldDependencies,
            sourceFieldExists,
            isFieldDependant = dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT || dataSet.type === dataSetType.CUSTOM,
            isRowRepeater = _.isPlainObject(fieldStructure.rowRepeaterTemplate) && _.isPlainObject(fieldStructure.rowRepeaterModel);

        if (isRowRepeater) {
            if (isFieldDependant) {
                if (!_.isNil(dataSet.dynamicDataSetDependency)) {
                    sourceFieldDependencies = dataSet.dynamicDataSetDependency.sourceFieldDependencies;
                    sourceFieldExists = sourceFieldDependencies.length > 0;

                    if (sourceFieldExists) {
                        let anyMatch = false;

                        _.each(fieldStructure.rowRepeaterTemplate.fields, function (templateObject) {
                            _.each(sourceFieldDependencies, function (sourceObject) {
                                if (templateObject.fieldTemplate.variableName === sourceObject.fieldName) {
                                    anyMatch = true;
                                }
                            });
                        });

                        if (anyMatch) {
                            result = _.replace(fieldStructure.rowRepeaterModel.uri, 'FormRowSummary', 'FormRow');
                        }
                    }
                }
            }
        }
        return result;
    };

    this.getDataSet = function (dataSetParams, formId) {
        let type = this.getDataSetType(dataSetParams.name);

        if (type === dataSetType.CUSTOM || type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
            return coreMediator.getDynamicDataSet(dataSetParams, formId);
        } else if (type === dataSetType.REPEATING_FORM) {
            return coreMediator.getRepeatingFormDynamicDataSetFormSetId(formId, dataSetParams.name).then(function (formSetId) {
                dataSetParams.ownerUri = 'com.firstbest.underwriting.form.FormSet:' + formSetId;
                return coreMediator.getDynamicDataSet(dataSetParams, formId);
            });
        } else {
            return coreMediator.getCachedDataSetByName(dataSetParams.name).then(function (dataSet) {
                return dataSet;
            });
        }
    };

    this.getDataItems = function (dataSetParams, formId) {
        return this.getDataSet(dataSetParams, formId).then(function (dataSet) {
            return dataSet.items;
        });
    };

    this.getDataSetType = function (dataSetName) {
        let type = dataSetType.STATIC,
            dataSetNameToTypeMap = coreMediator.getDataSetNameToTypeMap();

        if (!_.isNil(dataSetNameToTypeMap[dataSetName])) {
            type = dataSetNameToTypeMap[dataSetName];
        }

        return type;
    };

    this.getDataItemValue = function (dataItem) {
        let doesDataItemExist = !_.isNil(dataItem),
            doesDataItemValueExist = doesDataItemExist && !_.isNil(dataItem.value);
        return doesDataItemValueExist ? dataItem.value : null;
    };
};

angular.module('umCore')
    .service('dataSetUtil', DataSetUtil);
